{
  "clients.kind.lead": "Lead",
  "clients.kind.coldCall": "Cold call",
  "clients.kind.farming": "Resale owner",
  "clients.create.farming": "New resale owner",
  "clients.description.lead": "Inbound interest from ads, referrals and your website, ready to qualify.",
  "clients.description.cold-call": "Outbound calls to prospects: who answered, who's interested, who to call back.",
  "clients.description.farming": "Owners in your target compounds who may resell their unit, worked over time until they're ready to list it or buy again.",
  "clients.search": "Search name, phone or email…",
  "clients.loadFailed": "This list couldn't load. Check your connection and refresh the page.",
  "clients.matching": "{count, plural, one {# matches} other {# match}}",
  "clients.shown": "Showing {shown} of {total}",
  "clients.export": "Export",
  "clients.exported": "Exported: {name}",
  "clients.col.name": "Name",
  "clients.col.phone": "Phone",
  "clients.col.source": "Source",
  "clients.col.status": "Status",
  "clients.col.assignedTo": "Assigned to",
  "clients.col.created": "Added",
  "clients.col.interest": "Interest",
  "clients.col.unit": "Owned unit",
  "clients.interest.buy": "Buy",
  "clients.interest.sell": "Sell",
  "clients.stats.newThisWeek": "Added this week",
  "clients.call": "Call {phone}",
  "clients.whatsapp": "WhatsApp {phone}",
  "clients.status.change": "Change {name}'s status",
  "clients.status.pick": "Pick a status to move {name}. You'll confirm before anything changes.",
  "clients.status.readOnly": "Where {name} stands right now.",
  "clients.status.current": "Current",
  "clients.status.moveTo": "Move to {status}",
  "clients.status.confirmTitle": "Move to {status}?",
  "clients.status.confirmBody": "{name} will move to this status.",
  "clients.status.confirmBodyLead": "{name} will move to this status, and the time on it starts over.",
  "clients.status.confirm": "Move to {status}",
  "clients.status.moving": "Moving…",
  "clients.status.from": "From",
  "clients.status.to": "To",
  "clients.status.timerRestarts": "New time limit: {limit}",
  "clients.view.list": "List",
  "clients.view.board": "Board by status",
  "clients.action.profile": "Open profile",
  "clients.action.assign": "Assign",
  "clients.assign.title": "{count, plural, one {Assign 1 record} other {Assign # records}}",
  "clients.assign.copies": "Each person you pick gets their own copy to work. People who already have this phone number are skipped.",
  "clients.assign.search": "Search people…",
  "clients.assign.team": "{leader}'s team",
  "clients.assign.submit": "{count, plural, =0 {Assign} one {Assign to 1 person} other {Assign to # people}}",
  "clients.assign.done": "{count, plural, one {Record assigned.} other {# records assigned.}}",
  "clients.import.title": "Import {kind}",
  "clients.import.bodyAgents": "Upload the sheet, then choose who works these records. Each person gets their own copy.",
  "clients.import.bodyLead": "Upload the sheet. Rows can name their owner; otherwise they go to the person you pick, or to you.",
  "clients.import.agents": "Assign to",
  "clients.import.owner": "Default owner (optional)",
  "clients.import.done": "Import finished.",
  "clients.empty.title": "No {kind} yet",
  "clients.empty.body": "Add the first one, or import a sheet to start working them.",
  "clients.empty.filteredTitle": "Nobody matches",
  "clients.delete.title": "Delete {name}?",
  "clients.delete.body": "Their history goes with them. This can't be undone from the app.",
  "clients.delete.done": "Deleted.",
  "clients.form.editTitle": "Edit details",
  "clients.form.contact": "Contact",
  "clients.form.details": "Details",
  "clients.form.ownedUnit": "Owned unit",
  "clients.form.assignTo": "Assign to",
  "clients.form.campaign": "Campaign",
  "clients.filter.added": "Added",
  "clients.form.pickCampaign": "Pick a campaign",
  "clients.form.areas": "Areas to buy in",
  "clients.form.pickAreas": "Pick areas",
  "clients.form.notes": "Notes",
  "clients.form.secondPhone": "Second phone",
  "clients.form.email": "Email",
  "clients.form.address": "Address",
  "clients.form.pickSource": "Where did they come from?",
  "clients.form.pickStatus": "Choose a status",
  "clients.form.farmingAgents": "Each person you pick gets their own copy of this owner.",
  "clients.form.created": "Added.",
  "clients.form.error.name": "Enter their name.",
  "clients.form.error.phone": "Enter a valid phone number.",
  "clients.form.error.source": "Choose a source.",
  "clients.form.error.status": "Choose a status.",
  "clients.form.error.agent": "Choose who works this record.",
  "clients.form.error.developer": "Enter the developer.",
  "clients.form.error.unitCode": "Enter the unit code.",
  "clients.form.error.unitType": "Enter the unit type.",
  "clients.form.error.phase": "Enter the phase.",
  "clients.profile.back": "All {kind}",
  "clients.profile.notFound": "This person isn’t here",
  "clients.profile.call": "Call",
  "clients.profile.schedule": "Schedule a meeting",
  "clients.profile.assignedBy": "Assigned by",
  "clients.profile.meetingTitle": "Meeting · {name}",
  "clients.timeline.title": "Timeline",
  "clients.timeline.status": "changed the status to",
  "clients.timeline.created": "added this record",
  "clients.timeline.updated": "updated {fields}",
  "clients.timeline.emptyTitle": "Nothing yet",
  "clients.timeline.emptyBody": "Status changes and edits will build this person’s story here.",
  "clients.notice.newLeads": "{count, plural, one {1 new lead assigned to you} other {# new leads assigned to you}}",
  "clients.notice.open": "Open leads"
}
